import React from "react";
export const SuperAdminHome = () => {
  return (
    <div>
      <h1>Softwiz Superadmin Home</h1>
    </div>
  );
};
